// export const requestUrl = "https://47.108.185.159:8080" // 后端地址  
// export const requestUrl = "http://192.168.101.146:8080" // 后端地址
// export const requestUrl = "https://store.serviceli.cn" // 后端地址
export const requestUrl = "https://test-store.serviceli.cn" // 后端地址

export const baseUrl = "https://4b0942ae.r7.cpolar.top/" // 二维码跳转域名

//安全发 
export const safeSendType = '1'  // 1 安全发 2 非安全发